import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';

export const microsoftConsentGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
    const router = inject(Router);
    const state = route.queryParams['state'];
    if (state) {
        try {
            const encodedState = atob(state);
            const tenantId = encodedState.split('.')[0];
            return router.createUrlTree(['/', tenantId, 'admin', 'integrations', 'microsoft-response'], {
                queryParams: route.queryParams,
            });
        } catch (error) {
            console.error(error);
            return true;
        }
    }
    return true;
};
